export default "__VITE_ASSET__CeZRPJiX__"